module.exports = __webpack_public_path__ + "l.no1.0ba03c08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/l.no1.jpg
// module id = tWWS
// module chunks = 0